import {chartColorsArray} from "../../_common/styles/chartColors";

export const getOptionsLine = (xData, yData, getCustomTooltip) => {

  return {
    series: [{
      data: yData
    }],
    chart: {
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'straight'
    },
    colors: chartColorsArray,
    legend: {
      horizontalAlign: 'left'
    },
    yaxis: {
      opposite: false,
      decimalsInFloat: 0,
      labels: {
        show: true,
        align: 'center',
        formatter: function (val) {
          let str = val.toString().split(".");
          str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return str.join(".");
        }
      },
      axisBorder: {
        show: true,
        color: '#E5E6E6',
      },
    },
    xaxis: {
      categories: xData,
      labels: {
        rotate: 60,
        style: {
          fontSize: '12px',
        }
      }
    },
    tooltip: {
      custom: function ({series, seriesIndex, dataPointIndex}) {
        return getCustomTooltip({series, seriesIndex, dataPointIndex})
      }
    },
    grid: {
      row: {
        colors: ['#F3F6F9', 'transparent'],
        opacity: 0.3
      },
    },
  }
};

export const getOptionsBar = (xData, yData, getCustomTooltip) => {

  return {
      series: yData,
      chart: {
        redrawOnParentResize: true,
        redrawOnWindowResize: true,
        type: 'bar',
        zoom: { enabled: false },
        toolbar: { show: false },
        dropShadow: {
          enabled: true,
          top: 5,
          left: 0,
          blur: 8,
          opacity: 0.1
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 10,           // The "Liquid" pill shape
          borderRadiusApplication: 'end',
          columnWidth: '55%',        // Gives the bars some "heft"
        }
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: ['#fff'],
          fontSize: '12px',
        },
        offsetY: 10,
      },
      colors: chartColorsArray,
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'light',
          type: "vertical",
          shadeIntensity: 0.3,
          inverseColors: false,
          opacityFrom: 0.9,
          opacityTo: 1,
          stops: [0, 20, 100]
        }
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['rgba(255, 255, 255, 0.3)']
      },
      legend: {
        offsetY: 8,
        horizontalAlign: 'center',
        fontSize: '16px',
        inverseOrder: true,
        markers: {
          width: 12,
          height: 12,
          strokeColor: '#fff',
          offsetX: '-1px',
          radius: 12,
        },
      },
      yaxis: {
        opposite: false,
        decimalsInFloat: 0,
        labels: {
          show: true,
          align: 'center',
          style: { colors: '#94a3b8' }
        },
        tickAmount: 5,
        axisBorder: {
          show: true,
          color: '#E5E6E6',
        },
      },
      xaxis: {
        categories: xData,
        axisBorder: { show: false },
        labels: {
          rotate: 60,
          style: {
            fontSize: '12px',
            fontWeight: 500
          }
        }
      },
      tooltip: {
        custom: function ({series, seriesIndex, dataPointIndex}) {
          return getCustomTooltip({series, seriesIndex, dataPointIndex})
        }
      },
      grid: {
        borderColor: '#f1f5f9',
        row: {
          colors: ['#F3F6F9', 'transparent'],
          opacity: 0.3
        },
      }
  };
};
